<template>
  <v-dialog v-model="activeModal" max-width="460" content-class="modal-criar-link">
    <v-card class="criar-link-card">
      <div class="criar-link-header">
        <span class="criar-link-title">{{ $t('links.criarLinkDestino') }}</span>
        <v-icon class="criar-link-close" @click="closeModal">mdi-close</v-icon>
      </div>

      <div class="criar-link-body">
        <div class="criar-link-field">
          <label class="criar-link-label" for="criar-link-nome">{{ $t('links.nomeDoLink') }}</label>
          <v-text-field
            id="criar-link-nome"
            v-model="linkName"
            dense
            outlined
            hide-details
            placeholder="-"
            class="criar-link-input"
          ></v-text-field>
        </div>

        <div class="criar-link-field">
          <label class="criar-link-label" for="criar-link-url">{{ $t('links.urlDestino') }}</label>
          <v-text-field
            id="criar-link-url"
            v-model="destinationUrl"
            dense
            outlined
            hide-details
            placeholder="https://"
            class="criar-link-input"
          ></v-text-field>
        </div>
      </div>

      <div class="criar-link-footer">
        <v-btn
          depressed
          class="criar-link-salvar"
          :loading="loading"
          :disabled="!podeSalvar"
          @click="salvar"
          v-if="podeCriar"
        >
          {{ $t('common.save') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import Events from '@/core/service/events'

export default {
  name: 'ModalCriarLink',
  data: () => ({
    activeModal: false,
    loading: false,
    linkName: '',
    destinationUrl: '',
  }),
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('auth', ['user']),
    isAffiliate() {
      if (!this.user.jsonFlags) return false
      return this.user.jsonFlags.affiliateId
    },
    podeCriar() {
      return this.permiteAcao(this.$route, 'add') && this.isAffiliate
    },
    podeSalvar() {
      return Boolean(this.linkName.trim()) && Boolean(this.destinationUrl.trim())
    },
  },
  mounted() {
    Events.$on('links::openModalCriarLink', () => {
      this.activeModal = true
    })
  },
  methods: {
    ...mapActions('links', ['createDestinationLink']),
    closeModal() {
      this.activeModal = false
      this.linkName = ''
      this.destinationUrl = ''
    },

    salvar() {
      this.loading = true
      this.createDestinationLink({
        linkName: this.linkName,
        destinationUrl: this.destinationUrl,
      })
        .then(response => {
          const data = response.data || {}
          if (!data.url) throw new Error(this.$t('links.erroGerarLink'))

          successSnackbar(this.$t('links.linkCriado'))
          Events.$emit('links::listaItens')
          this.closeModal()
        })
        .catch(err => { errorSnackbar(err.error || err.message || this.$t('links.erroGerarLink')) })
        .finally(() => { this.loading = false })
    },
  }
}
</script>

<style lang="scss" scoped>
.criar-link-card {
  background: #1D1D29 !important;
  border-radius: 12px;
  color: #FFF;
}

.criar-link-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  border-bottom: 1px solid rgba(124, 124, 138, 0.2);
}

.criar-link-title {
  font-size: 17px;
  font-weight: 600;
  color: #FFF;
}

.criar-link-close {
  color: #7C7C8A !important;
  cursor: pointer;

  &:hover {
    color: #FFF !important;
  }
}

.criar-link-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 22px;
}

.criar-link-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.criar-link-label {
  font-size: 13px;
  font-weight: 600;
  color: #E4E4E7;
}

.criar-link-input::v-deep {
  .v-input__slot {
    background: #0D0F1D !important;
    border-radius: 8px;
    min-height: 44px;
  }

  fieldset {
    border-color: rgba(124, 124, 138, 0.25) !important;
  }

  input {
    color: #FFF !important;
    font-size: 14px;
  }

  input::placeholder {
    color: #7C7C8A !important;
  }

  &.v-input--is-focused fieldset {
    border-color: var(--v-primary-base) !important;
  }
}

.criar-link-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 0 22px 22px;
}

.criar-link-salvar {
  background: var(--v-primary-base) !important;
  color: #FFF !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
  min-height: 42px;
  padding: 0 20px;

  &.v-btn--disabled {
    background: rgba(255, 255, 255, 0.08) !important;
    color: rgba(255, 255, 255, 0.4) !important;
  }
}
</style>
